<template>
  <div class="tw:grid tw:gap-4">
    <template
      v-for="(message, messageIndex) in messages"
      :key="messageIndex"
    >
      <AIAssistantBaseChatRequest v-if="isAIAssistantUserMessage(message)">
        {{ message.message }}
      </AIAssistantBaseChatRequest>

      <AIAssistantBaseChatSuggestMessage
        v-else-if="isAIAssistantSuggestMessage(message)"
        :message="message"
        @suggestion="emit('suggestion', $event)"
      />

      <AIAssistantBaseChatModelMessage
        v-else-if="isAIAssistantModelMessage(message)"
        :message="message"
      >
        <template #controls>
          <slot
            :index="messageIndex"
            :model-message="message"
            name="modelControls"
          />
        </template>
      </AIAssistantBaseChatModelMessage>
    </template>
  </div>
</template>

<script setup lang="ts">
import AIAssistantBaseChatRequest from "shared/components/AI/AIAssistant/AIAssistantBaseChatRequest.vue";
import {
  type AIAssistantMessage,
  type AIAssistantModelMessage,
  isAIAssistantModelMessage,
  isAIAssistantSuggestMessage,
  isAIAssistantUserMessage,
} from "shared/composables/useAIAssistant";

import AIAssistantBaseChatModelMessage from "./AIAssistantBaseChatModelMessage.vue";
import AIAssistantBaseChatSuggestMessage from "./AIAssistantBaseChatSuggestMessage.vue";

interface AIAssistantBaseChatProps {
  messages: AIAssistantMessage[];
}

defineProps<AIAssistantBaseChatProps>();

const emit = defineEmits<{
  suggestion: [string];
}>();

defineSlots<{
  modelControls?(props: {
    modelMessage: AIAssistantModelMessage;
    index: number;
  }): any;
}>();
</script>
